import { ROUTE_NAMES } from './routeNames.const'

export const routeSituation = {
  path: '/situation',
  name: ROUTE_NAMES.situation,
  component: () =>
    import(
      /* webpackChunkName: "Situation" */ 'src/pages/PageSituation/PageSituation.vue'
    ),
  props: true,
}
